var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"mask-layer"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.maskActive),expression:"maskActive"}],staticClass:"mask-wrap",on:{"wheel":_vm.mouseEvent}},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }